import Modal from '../../../../../components/Modal';
import Body from '../Body';

type Props = {
    reviewId: string;
    isOpen: boolean;
    onClose: () => void;
    onAfterClose?: () => void;
};

export default function ReviewViewModal({ reviewId, isOpen, onClose, onAfterClose }: Props) {
    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            onAfterClose={onAfterClose}
            size="XXL_WIDTH"
            topAligned
            withPadding={false}
        >
            <Body reviewId={reviewId} />
        </Modal>
    );
}
